import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { authAPI } from '../../utils/api';
import { Alert, Spinner } from '../../components/ui';
import toast from 'react-hot-toast';

export default function AdminLogin() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { loginAdmin } = useAuth();
  const nav = useNavigate();

  const submit = async e => {
    e?.preventDefault();
    if (!username || !password) { setError('Enter your username and password.'); return; }
    setLoading(true); setError('');
    try {
      const r = await authAPI.adminLogin({ username, password });
      loginAdmin(r.data.token, r.data.admin);
      toast.success(`Welcome, ${r.data.admin.name}! 🎉`);
      nav('/admin');
    } catch (e) { setError(e.response?.data?.message || 'Invalid credentials.'); }
    finally { setLoading(false); }
  };

  return (
    <div style={{ minHeight:'100vh', background:'linear-gradient(145deg,#020a1f 0%,#060f2e 40%,#0d1e4d 70%,#1A3C8F 100%)', display:'flex', alignItems:'center', justifyContent:'center', padding:24, fontFamily:'var(--font-body)', position:'relative', overflow:'hidden' }}>
      {/* Blobs */}
      <div style={{ position:'absolute', width:600, height:600, background:'radial-gradient(circle,rgba(245,166,35,0.1),transparent 65%)', top:-180, right:-120, animation:'float 10s ease-in-out infinite', pointerEvents:'none' }} />
      <div style={{ position:'absolute', width:400, height:400, background:'radial-gradient(circle,rgba(80,120,255,0.07),transparent 65%)', bottom:-100, left:-80, animation:'float 13s ease-in-out infinite reverse', pointerEvents:'none' }} />

      {/* Grid dots background */}
      <div style={{ position:'absolute', inset:0, backgroundImage:'radial-gradient(rgba(255,255,255,0.04) 1px,transparent 1px)', backgroundSize:'40px 40px', pointerEvents:'none' }} />

      <div style={{ width:'100%', maxWidth:420, position:'relative', animation:'scaleIn 0.4s ease' }}>
        <div style={{ textAlign:'center', marginBottom:36 }}>
          <Link to="/" style={{ display:'inline-flex', alignItems:'center', gap:11, textDecoration:'none', marginBottom:20 }}>
            <div style={{ width:44,height:44,background:'rgba(245,166,35,0.18)',border:'1.5px solid rgba(245,166,35,0.38)',borderRadius:12,display:'flex',alignItems:'center',justifyContent:'center',fontSize:20 }}>🏆</div>
            <span style={{ fontFamily:'var(--font-heading)', fontSize:22, fontWeight:700, color:'#fff' }}>TNPSC <span style={{ color:'var(--gold)' }}>Hub</span></span>
          </Link>
          <div style={{ display:'inline-flex', alignItems:'center', gap:7, background:'rgba(220,53,69,0.15)', border:'1px solid rgba(220,53,69,0.3)', borderRadius:50, padding:'5px 14px', color:'#ff8899', fontSize:11, fontWeight:700, letterSpacing:'1px', textTransform:'uppercase' }}>
            🔐 Restricted Admin Access
          </div>
        </div>

        <div style={{ background:'rgba(255,255,255,0.04)', backdropFilter:'blur(20px)', borderRadius:22, padding:'36px 32px', border:'1px solid rgba(255,255,255,0.08)', boxShadow:'0 32px 64px rgba(0,0,0,0.35)' }}>
          <h2 style={{ fontFamily:'var(--font-heading)', fontSize:26, color:'#fff', marginBottom:6, textAlign:'center' }}>Admin Panel</h2>
          <p style={{ color:'rgba(255,255,255,0.35)', fontSize:13, textAlign:'center', marginBottom:26 }}>Sign in with your administrator credentials</p>

          {error && <Alert type="error" onClose={() => setError('')}>{error}</Alert>}

          <form onSubmit={submit}>
            <div className="form-group">
              <label style={{ display:'block', fontSize:12, fontWeight:600, color:'rgba(255,255,255,0.5)', marginBottom:7, letterSpacing:'0.5px', textTransform:'uppercase' }}>Username</label>
              <div className="input-wrap">
                <span className="input-icon" style={{ color:'rgba(255,255,255,0.3)' }}>👤</span>
                <input className="form-input" style={{ background:'rgba(255,255,255,0.07)', border:'1.5px solid rgba(255,255,255,0.1)', color:'#fff' }} placeholder="Admin username" value={username} onChange={e => setUsername(e.target.value)} autoComplete="username" autoFocus />
              </div>
            </div>

            <div className="form-group">
              <label style={{ display:'block', fontSize:12, fontWeight:600, color:'rgba(255,255,255,0.5)', marginBottom:7, letterSpacing:'0.5px', textTransform:'uppercase' }}>Password</label>
              <div className="input-wrap">
                <span className="input-icon" style={{ color:'rgba(255,255,255,0.3)' }}>🔒</span>
                <input type={show ? 'text':'password'} className="form-input" style={{ background:'rgba(255,255,255,0.07)', border:'1.5px solid rgba(255,255,255,0.1)', color:'#fff', paddingRight:44 }} placeholder="Admin password" value={password} onChange={e => setPassword(e.target.value)} autoComplete="current-password" />
                <button type="button" onClick={() => setShow(s=>!s)} style={{ position:'absolute',right:12,top:'50%',transform:'translateY(-50%)',background:'none',border:'none',cursor:'pointer',fontSize:15,color:'rgba(255,255,255,0.35)',padding:2 }}>{show ? '🙈':'👁️'}</button>
              </div>
            </div>

            <button type="submit" style={{ width:'100%', padding:'14px', background:'linear-gradient(135deg,var(--gold),var(--gold-dark))', border:'none', borderRadius:12, fontFamily:'var(--font-body)', fontSize:15, fontWeight:800, color:'var(--blue-dark)', cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center', gap:8, boxShadow:'0 6px 24px rgba(245,166,35,0.35)', transition:'all 0.25s', marginTop:4 }} disabled={loading}
              onMouseEnter={e => { if (!loading) e.currentTarget.style.transform='translateY(-2px)'; }}
              onMouseLeave={e => e.currentTarget.style.transform='translateY(0)'}>
              {loading ? <><Spinner size={17} color="white" /> Logging in...</> : '🔐 Login to Admin Panel'}
            </button>
          </form>
        </div>

        <div style={{ textAlign:'center', marginTop:20 }}>
          <Link to="/login" style={{ color:'rgba(255,255,255,0.3)', fontSize:13, transition:'color 0.2s' }}
            onMouseEnter={e => e.target.style.color='rgba(255,255,255,0.6)'}
            onMouseLeave={e => e.target.style.color='rgba(255,255,255,0.3)'}>
            ← Student Login
          </Link>
        </div>
      </div>
      <style>{`
        @keyframes float{0%,100%{transform:translateY(0)}50%{transform:translateY(-16px)}}
        @keyframes scaleIn{from{opacity:0;transform:scale(0.93)}to{opacity:1;transform:scale(1)}}
        input::placeholder{color:rgba(255,255,255,0.2)!important}
        input:focus{border-color:rgba(245,166,35,0.45)!important;box-shadow:0 0 0 3px rgba(245,166,35,0.12)!important}
      `}</style>
    </div>
  );
}
